module.exports = (function($) {
  $.fn.truncate = function(options) {
    var settings = $.extend({
        row: 1,
        ellipsis: "...",
        more: ""
      },
      options
    );
    var string = this.text();

    function calRows() {
      return this.height() / parseInt(this.css("line-height"));
    }

    var getRows = calRows.bind(this);

    while (true) {
      if (Math.floor(getRows()) <= settings.row) break;
      else {
        string = string.slice(0, -1);
        this.html(string + settings.ellipsis + settings.more);
        if (!string) break;
      }
    }
  };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// /home/semantica-admin/production2024/web/app/themes/cedarberg-sage9/node_modules/truncate-text/lib/index.js
// module id = 11
// module chunks = 0